import './suspense.css';

import { BusySpinner } from "../overlay/components/Busy";
import { PulseCardPlaceholder } from "../placeholders/PulseCardPlaceholder";
import { PulseListPlaceholder } from "../placeholders/PulseListPlaceholder"
import { Loader } from '@progress/kendo-react-indicators';
import { ListPlaceholder } from '../placeholders/ListPlaceholder';
import FloatingButtonContainer from '../FloatingButtonContainer';
import FloatingActionButton from '../FloatingActionButton';
import { UploadIcon } from '../icons/Icons';

interface SuspenseFallbackProps {
    title?: string,
    titleIcon?: string,
    size?: string,
    count?: number,
    mode?: string,
    text?: string,
    showUploadButton?: boolean
}

export const SuspenseFallback = ({
    title = "",
    titleIcon = "",
    size = "large",
    count = 5,
    mode = "list",
    text = "",
    showUploadButton = false
}: SuspenseFallbackProps) => {

    return (
        <>
            {
                (() => {
                    switch (mode) {
                        case "list":
                            return <ListPlaceholder count={count} size={size} />
                        case "pulse-card":
                            return <PulseCardPlaceholder title={title} titleIcon={titleIcon} size={size} />;
                        case "pulse-list":
                            return <PulseListPlaceholder title={title} titleIcon={titleIcon} size={size} count={count} />;
                        case "text":
                            return (
                                <div className="suspense-content">
                                    <div style={{ background: "lightblue", color: "#333" }}>
                                        <div>{text}</div>
                                        <div><Loader type={"pulsing"} /></div>
                                    </div>
                                </div>
                            )
                        default:
                            return (
                                <div className="suspense-content">
                                    <div className="k-d-grid k-justify-items-center k-mt-2 k-h-full align-items-center">
                                        <BusySpinner />
                                    </div>
                                </div>
                            )
                    }
                })()
            }
            {
                showUploadButton &&
                <FloatingButtonContainer hasBottomNavigation={true}>
                    <FloatingActionButton
                        themeColor={"secondary"}
                        disabled={true}
                        svgIcon={UploadIcon}
                    />
                </FloatingButtonContainer>
            }
        </>
    )
}
